AuthRoute = require 'mixins/authenticated-route'

{ timedPromise } = require 'utils/rsvp'

App.BonusCategoriesIndexRoute = Em.Route.extend AuthRoute,
  store: Em.inject.service()

  model: (params) ->
    @store.filter 'client-tag', { detailed: true, bonus: true }, (tag) ->
      tag.get('is_bonus_category')